import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gen-auto-ship-shipment-schedule',
  templateUrl: './auto-ship-shipment-schedule.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GenAutoShipShipmentScheduleComponent {

  numberOfShipments: number = 0;

  onNumberOfShipmentsChange(count: number): void {
    this.numberOfShipments = count;
  }
}
